import { render } from "./AiTripConsultView.vue?vue&type=template&id=c0f92d1e&scoped=true"
import script from "./AiTripConsultView.vue?vue&type=script&lang=js"
export * from "./AiTripConsultView.vue?vue&type=script&lang=js"

import "./AiTripConsultView.vue?vue&type=style&index=0&id=c0f92d1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0f92d1e"]])

export default __exports__